/*
设备完好率
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import FormCore from "@/components/display/form/formCore";
// 业务接口
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import "@/assets/stylus/data_analysis.styl";
import { Select, Affix, Tooltip, Form } from "antd";
import { getCityList } from "@/fetch/fetchApi";
import { QuestionCircleOutlined } from "@ant-design/icons";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import StubIntactTop100 from "./stubIntactTop100";
import StationIntactTop10 from "./stationIntactTop10";
import StubDay from "./stubDay";
import StubMonth from "./stubMonth";

const FormItem = Form.Item;

const { Option } = Select;

@CityDataFilterHoc
@connect((state) => state)
class StubIntact extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    console.log(this.props);
    this.internationalization = this.props.intl.messages.stubIntact;
    this.state = {
      type: "",
      typeOption: [
        {
          // 运营类型细项 初始化option选项
          text: "全部",
          value: "",
        },
      ],
      timeType: "pickMonth", // 查询form表单 日期表单选择方式  pickMonth：年月选择； pickDate：年月日选择
      choosedData: moment(new Date()).subtract(0, "d").format("YYYY.MM"), // 选择的日期，默认是当月
      table1Value: { children: "完好率", value: "2" }, // 电站Top10 排序内容初始化
      table1sort: { children: "从低到高", value: "1" }, // 电站Top10 排序方式初始化
      table2Value: { children: "完好率", value: "2" }, // 设备Top100 排序内容初始化
      table2sort: { children: "从低到高", value: "1" }, // 设备Top100 排序方式初始化
      param: {
        // 传递子组件查询参数
        cityId: "", // 地区
        type: "", // 设备类型
        operationProperty: "", // 运营类型-运维/运营
        operationMode: "", // 运营类型细项
        date: moment(new Date()).format("YYYY-MM"), // 时间->默认当月
      },
      table1SortParam: {
        // 电站Top10排序方式设置
        sortKey: "2", // 2：完好率。1：离线率：0：故障率
        sortFun: "1", // 1：由低到高。-1：由高到低
      },
      table2SortParam: {
        // 设备Top100排序方式设置
        sortKey: "2", // 2：完好率。1：离线率：0：故障率
        sortFun: "1", // 1：由低到高。-1：由高到低
      },
    };
  }

  // 电站top10设置ref
  formRef = React.createRef();

  // 设备top100设置ref
  formRef2 = React.createRef();

  /**
   * 初始化form查询表单
   */
  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

  componentDidMount() {
    console.log(this.refs.select1);
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  /**
   * 初始化form查询表单数据
   */
  initFormConfig = () => {
    const option1 = [
      {
        text: "全部",
        value: "",
      },
      {
        text: "星充直营",
        value: "2",
      },
      {
        text: "加盟直营",
        value: "3",
      },
      {
        text: "联营",
        value: "1",
      },
      {
        text: "他营",
        value: "0",
      },
      {
        text: "人人电站",
        value: "5",
      },
    ];

    const option2 = [
      {
        text: "全部",
        value: "",
      },
      {
        text: "私桩",
        value: "0",
      },
      {
        text: "非私桩",
        value: "1",
      },
    ];

    const option3 = [
      {
        text: "全部",
        value: "",
      },
    ];

    const formConfig = {
      childItems: [
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.internationalization.placeholder2, // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区:",
          className: "allshow",
          sourceApi: getCityList,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              width: "95px",
              options: [
                {
                  text: "全部",
                  value: "",
                },
                {
                  text: "运营",
                  value: "1",
                },
                {
                  text: "运维",
                  value: "0",
                },
              ],
              placeholder: "请选择",
              param: {
                name: "operationProperty",
                type: "string",
              },
              labelName: "运营类型:",
              required: false,
              onChange: (value, form) => {
                // 运营类型总项选择后，设置细项
                form.setFieldsValue({
                  stubType: value,
                  stubType2: "",
                });
                console.log(value);
                const stubType2List = [];
                if (value === "0") {
                  stubType2List.push(...option2);
                } else if (value === "1") {
                  stubType2List.push(...option1);
                } else if (value === "") {
                  stubType2List.push(...option3);
                }
                this.setState(
                  {
                    typeOption: [...stubType2List],
                  },
                  () => {
                    this.setState({
                      formConfig: this.initFormConfig(),
                    });
                  },
                );
              },
            },
            {
              type: "select",
              width: "95px",
              placeholder: "请选择",
              param: {
                name: "operationMode",
                type: "string",
              },
              labelName: "",
              options: this.state.typeOption,
              required: false,
            },
          ],
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.type0, // '全部',
              value: "",
            },
            {
              text: "交流电",
              value: "0",
            },
            {
              text: "直流电",
              value: "1",
            },
            {
              text: "交直流",
              value: "2",
            },
          ],
          placeholder: "请选择设备类型",
          param: {
            name: "type",
            type: "string",
          },
          labelName: this.internationalization.title4, // '设备类型:',
          required: false,
          defaultValue: "",
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              options: [
                {
                  text: "月",
                  value: "1",
                },
                {
                  text: "日",
                  value: "0",
                },
              ],
              width: "80px",
              // placeholder: ['请选择',],
              param: {
                name: "searchType",
                type: "string",
              },
              onChange: (value, form) => {
                // 日期类型选择后执行，设置日期选择样式
                form.setFieldsValue({
                  searchType: value,
                });
                if (value === "0") {
                  this.setState(
                    {
                      timeType: "pickDate",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                } else if (value === "1") {
                  this.setState(
                    {
                      timeType: "pickMonth",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                }
              },
              allowClear: false,
              defaultValue: "1",
              labelName: "日期:",
              required: false,
            },
            {
              type: "date",
              dateType: this.state.timeType,
              width: "140px",
              allowClear: false,
              // placeholder: ['请选择',],
              param: {
                name: "date",
                type: "object",
              },
              disabledDate: (current) => {
                let flag = false;
                if (current < moment(new Date("2020-01-01")).endOf("day")) {
                  flag = true;
                }

                if (current && current > moment(new Date()).endOf("day")) {
                  flag = true;
                }
                return flag;
              },
              defaultValue:
                this.state.timeType === "pickMonth"
                  ? moment(new Date()).subtract(0, "m")
                  : moment(new Date()).subtract(0, "d"),
              required: false,
            },
          ],
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询',
              handler: (e, param) => {
                /**
                 * flag - > 判断data参数是否是monent类型
                 * cityId -> 格式化cityId
                 */
                // let flag = moment.isMoment(param.date);
                const cityId = param.cityId === undefined
                  ? ""
                  : param.cityId
                    .toString()
                    .slice(param.cityId.toString().lastIndexOf(",") + 1, param.cityId.toString().length);

                /**
                 * 设置参数，将电站top10排序方式，和设备TOP100排序方式 初始化
                 */
                let dateSet = '';
                if (param.searchType === "1") {
                  if (param.date) {
                    dateSet = param.date.format("YYYY-MM");
                  } else {
                    dateSet = moment(new Date()).format("YYYY-MM");
                  }
                } else {
                  if (param.date) {
                    dateSet = param.date.format("YYYY-MM-DD");
                  } else {
                    dateSet = moment(new Date()).format("YYYY-MM-DD");
                  }
                }
                this.setState({
                  param: {
                    cityId: cityId,
                    type: param.type ? param.type : "",
                    operationProperty: param.operationProperty ? param.operationProperty : "",
                    operationMode: param.operationMode ? param.operationMode : "",
                    date: dateSet,
                  },
                  choosedData:
                    param.searchType === "1" ? param.date.format("YYYY.MM") : moment(param.date).format("YYYY.MM.DD"),
                  table1SortParam: {
                    sortKey: "2",
                    sortFun: "1",
                  },
                  table2SortParam: {
                    sortKey: "2",
                    sortFun: "1",
                  },
                  table1Value: { children: "完好率", value: "2" },
                  table1sort: { children: "从低到高", value: "1" },
                  table2Value: { children: "完好率", value: "2" },
                  table2sort: { children: "从低到高", value: "1" },
                });

                // 重置 电站top10\设备Top100 排序方式
                this.formRef.current.setFieldsValue({
                  top100Slect1: "2",
                  top100Slect2: "1",
                });
                this.formRef2.current.setFieldsValue({
                  top10Slect1: "2",
                  top10Slect2: "1",
                });
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "stubIntactTable",
    };
    return formConfig;
  };

  /**
   *
   * tableKey：设置的健值名称
   * sortValue：设置的值
   */
  changeTableSort = (tableKey, sortValue) => {
    this.setState(
      {
        [tableKey]: sortValue, // {text:sortValue.props.children,value:sortValue.props.value},
      },
      () => {
        // 如果是 电站Top10 的相关设置，更改top10的排序方式
        if (tableKey === "table1Value" || tableKey === "table1sort") {
          this.setState({
            table1SortParam: {
              sortKey: this.state.table1Value.value,
              sortFun: this.state.table1sort.value,
            },
          });
        }

        // 如果是 设备Top100  的相关设置，更改top100的排序方式
        if (tableKey === "table2sort" || tableKey === "table2Value") {
          this.setState({
            table2SortParam: {
              sortKey: this.state.table2Value.value,
              sortFun: this.state.table2sort.value,
            },
          });
        }
      },
    );
  };

  /**
   * 选择按月呈现中的数据项后，传递执行
   */
  changeMonth = (value) => {
    console.log(moment(value).format("YYYY-MM-DD"));

    // 设置参数，初始化排序方式
    this.setState(
      {
        param: {
          cityId: this.state.param.cityId,
          operationProperty: this.state.param.operationProperty,
          operationMode: this.state.param.operationMode,
          date: moment(value).format("YYYY-MM"),
          type: this.state.param.type,
        },
        table1SortParam: {
          sortKey: "2",
          sortFun: "1",
        },
        table2SortParam: {
          sortKey: "2",
          sortFun: "1",
        },
        choosedData: moment(value).format("YYYY.MM"),
      },
      () => {
        // 初始化排序方式
        this.formRef.current.setFieldsValue({
          top100Slect1: "2",
          top100Slect2: "1",
        });
        this.formRef2.current.setFieldsValue({
          top10Slect1: "2",
          top10Slect2: "1",
        });
      },
    );
  };

  /**
   * 选择按日呈现中的数据项后，传递执行
   */
  changeDay = (value) => {
    // 设置参数，初始化排序方式
    this.setState(
      {
        param: {
          cityId: this.state.param.cityId,
          operationProperty: this.state.param.operationProperty,
          operationMode: this.state.param.operationMode,
          date: moment(value).format("YYYY-MM-DD"),
          type: this.state.param.type,
        },
        table1SortParam: {
          sortKey: "2",
          sortFun: "1",
        },
        table2SortParam: {
          sortKey: "2",
          sortFun: "1",
        },
        choosedData: moment(value).format("YYYY.MM.DD"),
      },
      () => {
        // 初始化排序方式
        this.formRef.current.setFieldsValue({
          top100Slect1: "2",
          top100Slect2: "1",
        });
        this.formRef2.current.setFieldsValue({
          top10Slect1: "2",
          top10Slect2: "1",
        });
      },
    );
  };

  render() {
    // 排序方式
    const sortTypeOption = [
      { label: "完好率", value: "2" },
      { label: "故障率", value: "0" },
      { label: "离线率", value: "1" },
      // {label:'可用率',value:'3'}
    ];
    const sortFuncOption = [
      { label: "从低到高", value: "1" },
      { label: "从高到低", value: "-1" },
    ];
    const val = (
      <div className='analysis' ref='stubIntact' style={{ height: "100%", overflowY: "auto" }}>
        <Affix target={() => this.refs.stubIntact}>
          <div className='analysis-title stub-intact-rate-page'>
            <FormCore formConfig={this.state.formConfig} />
          </div>
        </Affix>
        {true ? (
          <div></div>
        ) : (
          <div>
            <div className='analysis-item' style={{ borderRadius: "6px" }}>
              <div className='analysis-item-title analysis-title-font'>按月呈现:</div>
            </div>

            <div>{/* <StubDate params={this.state} onAdd={this.props.onAdd}></StubDate> */}</div>
          </div>
        )}
        <div className='analysis-item'>
          <div className='analysis-item-title analysis-title-font'>按月呈现:</div>
        </div>
        <div>
          <StubMonth param={this.state.param} changeMonth={this.changeMonth} />
        </div>

        <div className='analysis-item'>
          <div className='analysis-item-title analysis-title-font'>按日呈现:</div>
        </div>
        <StubDay param={this.state.param} changeDay={this.changeDay} />

        <div className='analysis-item hasSelect'>
          <div className='analysis-item-title analysis-title-font'>
            {this.state.choosedData}TOP10电站{" "}
            <Tooltip title='可点击上方折线图的日期，展示选中日期对应的TOP10电站数据'>
              {" "}
              <QuestionCircleOutlined style={{ margin: "0 10px", color: "#999" }} />
            </Tooltip>
            :
          </div>
          <div className='paixu'>
            排序方式：
            <Form ref={this.formRef2}>
              <FormItem name='top10Slect1' initialValue="2">
                <Select
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    this.changeTableSort("table1Value", option);
                  }}
                  style={{ width: 90, marginRight: 10, fontSize: 12 }}>
                  {sortTypeOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
              <FormItem name='top10Slect2' initialValue="1">
                <Select
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    this.changeTableSort("table1sort", option);
                  }}
                  style={{ width: 90, fontSize: 12 }}>
                  {sortFuncOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Form>
          </div>
        </div>

        <StationIntactTop10
          param={this.state.param}
          sort={this.state.table1SortParam}
          onAdd={this.props.onAdd} />

        <div className='analysis-item hasSelect'>
          <div className='analysis-item-title analysis-title-font'>
            {this.state.choosedData}TOP100设备{" "}
            <Tooltip title='可点击上方折线图的日期，展示选中日期对应的TOP100设备数据'>
              {" "}
              <QuestionCircleOutlined style={{ margin: "0 10px", color: "#999" }} />
            </Tooltip>
            :
          </div>
          <div className='paixu'>
            排序方式：
            <Form ref={this.formRef}>
              <FormItem name='top100Slect1' initialValue="2">
                <Select
                  ref='select2'
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    this.changeTableSort("table2Value", option);
                  }}
                  style={{ width: 90, marginRight: 10, fontSize: 12 }}>
                  {sortTypeOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>

              <FormItem name='top100Slect2' initialValue="1">
                <Select
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    this.changeTableSort("table2sort", option);
                  }}
                  style={{ width: 90, fontSize: 12 }}>
                  {sortFuncOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Form>
          </div>
        </div>
        <StubIntactTop100
          param={this.state.param}
          sort={this.state.table2SortParam}
          onAdd={this.props.onAdd} />

        <div>{/* <StubType params={this.state} onAdd={this.props.onAdd}></StubType> */}</div>
      </div>
    );

    return val;
  }
}

export default injectIntl(StubIntact);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stubIntact.js